import { Box, Grid, Container, Typography } from '@mui/material';
import vittalBg from 'assets/images/vittalBg.svg';
import VittalRamakrishna from 'assets/images/VittalRamakrishna.png';
import linkedIn from 'assets/images/linkedIn.svg';
import Link from 'components/Link';
import { OurPrinciples } from 'components/v2/AboutPage/OurPrinciples';
import { Hiring } from 'components/v2/AboutPage/Hiring';

const About = () => {
  return (
    <>
      <Box
        sx={{
          background: 'rgba(243, 249, 236, 1)',
        }}
      >
        <Container>
          <Grid container>
            <Grid item md={7} xs={12} position="relative">
              <Box
                position="absolute"
                sx={{
                  transform: 'rotate(25.76deg)',
                  filter: 'blur(98px)',
                  opacity: 0.32,
                  background: '#D3FE67',
                  height: {
                    xs: '50%',
                    md: '100%',
                  },
                  width: '20%',
                  // right: '40%',
                  right: {
                    xs: '40%',
                    md: '10%',
                  },
                  top: {
                    xs: '30%',
                    md: '0%',
                  },
                  zIndex: 0,
                }}
              />
              <Box position="relative" zIndex={5}>
                <Typography
                  // mt="136px"
                  sx={{
                    mt: {
                      xs: '70px',
                      xl: '136px',
                    },
                    fontSize: {
                      xs: 16,
                      md: 24,
                    },
                  }}
                  color="#FF6446"
                  fontWeight={600}
                  // fontSize={24}
                  lineHeight="24px"
                  letterSpacing="0.01em"
                >
                  Democracy is the path ahead
                </Typography>
                <Typography
                  color="#111"
                  component="h1"
                  fontWeight={900}
                  lineHeight="82.03px"
                  sx={{
                    mt: {
                      xs: 0,
                      md: 3,
                    },
                    '& span': {
                      background:
                        'linear-gradient(270.02deg, #4CBFA9 0.02%, rgba(122, 216, 198, 0.04) 99.98%);',
                    },
                    fontSize: {
                      xs: 50,
                      md: 70,
                    },
                    lineHeight: {
                      xs: '58.59px',
                      md: '82.03px',
                    },
                    letterSpacing: {
                      xs: '-0.02em',
                    },
                  }}
                >
                  We are <span>Democratizing</span>
                  <br />
                  Fundraising in India
                </Typography>
                <Typography
                  color="rgba(17, 17, 17, 0.7)"
                  sx={{
                    '& strong': {
                      color: '#FF6446',
                      fontWeight: 500,
                    },
                    mb: {
                      xs: 7,
                      md: '135px',
                    },
                    fontSize: {
                      xs: 16,
                      md: 22,
                    },
                    lineHeight: {
                      xs: '28px',
                      md: '34px',
                    },
                    mt: {
                      xs: '10px',
                      md: '34px',
                    },
                  }}
                  // mb="135px"
                >
                  POD is a Bengaluru-based fundraising platform. Founded by
                  <strong> Vittal Ramakrishna</strong> and backed by{' '}
                  <strong>Elina Investments</strong>, the platform aspires to
                  nurture a healthy ecosystem for investing and fundraising.
                </Typography>
              </Box>
            </Grid>
            <Grid item md={5} flexShrink={0} xs={12}>
              <Box
                height="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                sx={{
                  '& .vittal-bg': {
                    width: '100%',
                  },
                  alignItems: {
                    xs: 'center',
                    md: 'flex-end',
                  },
                }}
              >
                <Box position="relative">
                  <img
                    className="vittal-bg"
                    src={vittalBg.src}
                    alt="image background"
                  />
                  <Box
                    width="50%"
                    position="absolute"
                    sx={{
                      // width: '80%',
                      // aspectRatio: '1',
                      '& img': {
                        display: 'block',
                        width: '100%',
                        // width: '80%',
                      },
                      right: '30%',
                      bottom: '11.5%',
                    }}
                  >
                    <img src={VittalRamakrishna.src} alt="Vittal Ramkrishna" />
                  </Box>
                </Box>
                <Box
                  sx={{
                    alignSelf: {
                      xs: 'flex-end',
                      // md: 'center',
                    },
                    pr: {
                      xs: 4,
                      md: 4,
                    },
                  }}
                  textAlign="right"
                >
                  <Typography
                    color="#FF6446"
                    fontSize={20}
                    fontWeight={600}
                    letterSpacing="0.01em"
                    lineHeight="24.94px"
                  >
                    Founder, CEO
                  </Typography>
                  <Typography
                    mt="3px"
                    color="#1E3841"
                    fontSize={24}
                    fontWeight={700}
                    letterSpacing="0.01em"
                    lineHeight="29.93px"
                  >
                    Vittal Ramakrishna
                  </Typography>
                  <Link
                    sx={{ mt: 1, display: 'inline-block' }}
                    href="https://www.linkedin.com/in/vittalramakrishna"
                    target="_blank"
                  >
                    <img src={linkedIn.src} alt="linkedIn link icon" />
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box bgcolor="#F8FBF5">
        <OurPrinciples />
      </Box>
      <Hiring />
    </>
  );
};

export default About;
